import { useQuery } from "@tanstack/react-query";
import { orpc } from "@/frontend/orpc-client";

/** Loads billing_state for the caller's active org (nullable for unmigrated orgs). */
export function useBillingStateQuery() {
  return useQuery(orpc.billing.getState.queryOptions({ input: {} }));
}
